import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import ClinicalDashboard from './components/ClinicalDashboard/ClinicalDashboard';
import PatientList from './components/PatientList/PatientList';
import PatientDetail from './components/PatientDetail/PatientDetail';
import Settings from './components/Settings/Settings';
import ProviderCalendar from './components/Calendar/ProviderCalendar';
import Reports from './components/Reports/Reports';
import Layout from './components/Layout/Layout';
import { PatientProvider } from './contexts/PatientContext';
import { DashboardProvider } from './contexts/DashboardContext';
import ErrorBoundary from './components/Common/ErrorBoundary';

const pageVariants = {
  initial: { opacity: 0 },
  in:      { opacity: 1 },
  out:     { opacity: 0 },
};

const pageTransition = {
  type: 'tween',
  ease: 'anticipate',
  duration: 0.3,
};

const App = () => {
  return (
    <ErrorBoundary>
      <PatientProvider>
        <DashboardProvider>
          <Layout>
            <motion.div
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={{ duration: 0.2 }}
              style={{ willChange: 'opacity' }}
            >
              <Routes>
                <Route path="/"            element={<ClinicalDashboard />} />
                <Route path="/dashboard"   element={<ClinicalDashboard />} />
                <Route path="/patients"    element={<PatientList />} />
                <Route path="/patient/:id" element={<PatientDetail />} />
                <Route path="/reports"     element={<Reports />} />
                <Route path="/settings"    element={<Settings />} />
                <Route path="/calendar"   element={<ProviderCalendar />} />
              </Routes>
            </motion.div>
          </Layout>
        </DashboardProvider>
      </PatientProvider>
    </ErrorBoundary>
  );
};

export default App;
